import { Card, CardBody, Divider, CardFooter, CardHeader } from "@nextui-org/react";

export interface CardDropDownOption {
    key: string;
    style: string;
    color: string;
    onPress: (data: any) => void;
    text: string;
}

export interface CardUIProps {
    id: string;
    name: string;
    description: string;
    /** Rendered in the body, immediately after the description. */
    bodyExtra?: JSX.Element;
    footerItems?: JSX.Element;
    view?: boolean;
    cardSize?: string;
    dropDownElement?: JSX.Element;
}

export function CardUI(props: Readonly<CardUIProps>) {
    const { id, name, description, bodyExtra, footerItems, view, cardSize, dropDownElement } = props;

    if (view === false) return null;

    return <Card className={`border cursor-pointer ${cardSize}`} shadow="sm" key={id + '-key'} id={id + '-id'}>
        <CardHeader className="flex justify-between items-center  text-foreground font-poppins text-lg font-semibold leading-7">
            {name}
            {dropDownElement}
        </CardHeader>
        <CardBody className={`overflow-hidden flex flex-col justify-between pt-0 mt-0 gap-2 `}>
            <span className="truncate-3-lines  text-default-500 font-poppins text-sm font-normal leading-5">
                {description}
            </span>
            {bodyExtra}
        </CardBody>
        <Divider />
        <CardFooter className="flex justify-end gap-2">
            {footerItems}
        </CardFooter>
    </Card>;
}

export default CardUI;